export default __webpack_public_path__ + "static/media/icon-checkbox-input-checked-v1.128c619c.svg";